// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { requiredProductsStyles } from "@steiner/App/Components/ProductDetails/RequiredProducts";
import AlertWarning from "@steiner/XDL/Icons/AlertWarning";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

requiredProductsStyles.container = {
    css: css`
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid ${color("common.border")};
        ${xScreen("lte", "md")} {
            margin-bottom: 20px;
        }
    `,
};

requiredProductsStyles.title = {
    size: 18,
    weight: fontConfig.weight.bold,
    lineHeight: "22px",
    css: css`
        margin-bottom: 8px;
        display: flex;
        gap: 6px;
    `,
};

requiredProductsStyles.titleIcon = {
    src: AlertWarning,
    color: "primary",
    size: 20,
};

requiredProductsStyles.table = {
    css: css`
        width: auto;
    `,
};